import create from 'zustand'

import type { ICeritaPraktikTrackerParams } from 'types/cerita-praktik'
import type { State } from 'zustand'

interface ICeritaPraktikTrackerParamsState extends State {
  trackerParams: ICeritaPraktikTrackerParams
  setTrackerParams: (params: ICeritaPraktikTrackerParams) => void
}

export const useCeritaPraktikTrackerParamsStore =
  create<ICeritaPraktikTrackerParamsState>((set) => ({
    trackerParams: {
      category: '',
      contentId: '',
      creatorEmails: '',
      numOfBlocks: 0,
      numOfImages: 0,
      numOfSections: 0,
      numOfWords: 0,
      revisionId: '',
    },
    setTrackerParams: (trackerParams) => set(() => ({ trackerParams })),
  }))
